// extracted by mini-css-extract-plugin
export var CardRichText = "styles-module--CardRichText--f6776";
export var cardsWrapper = "styles-module--cardsWrapper--bec05";